<template>
  <div>
    <v-card>
      <v-data-table
        dense
        :headers="headers"
        :items="SearchedCalcData"
        :server-items-length="pagination.itemsLength"
        :options.sync="pagination"
        :loading="loading"
        :footer-props="{
          'items-per-page-options': [25, 50, 100],
        }"
        loading-text="Считываем данные ..."
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <!-- <v-toolbar-title>Мои расчеты</v-toolbar-title> -->
            <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
            <!-- <v-spacer></v-spacer> -->
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Найти"
              single-line
              hide-details
              clearable
            />
          </v-toolbar>
        </template>
        <template v-slot:item.numberlot="{ item }">
          <div v-if='item.purchase_number'>
              <a
              class="bluelink"
              @click.prevent="getCustomerinfoForMyCalculations(item)"
            >
              {{ item.purchase_number }}
            </a>
            <!-- <v-icon style="float: right" class="mr-2">edit</v-icon> -->
            <br />
            <span >Лот: {{ item.lot_number }}</span>
            <template v-if="item.smp == 'да'">
              <span class="ml-2" style="color: red">СМП</span>
            </template>
          </div>
          <div v-else>
            N/A
          </div>
        </template>
        <template v-slot:item.zakgar="{ item }">
          {{ purchasesIdToSting(item.purchase) }}
          <br />
          {{ quaranteesIdToString(item.quarantee) }}
        </template>
        <template v-slot:item.data="{ item }">
          {{ item.data }}
        </template>
        <template v-slot:item.bg="{ item }">
          {{ addCommas(item.summ) }} ₽
          <br />
          с {{ moment(item.date_from).format("DD.MM.YYYY") }} <br /> по {{ moment(item.date_to).format("DD.MM.YYYY") }} <br /> {{ item.days }} дн.
        </template>
        <template v-slot:item.client_innname="{ item }">
          <div v-if='item.client_inn || item.client_name'>
            {{item.client_inn}} | {{item.client_name}}
          </div>
          <div v-else>N/A</div>
        </template>
        <template v-slot:item.winner_innname="{ item }">
          <div v-if='item.customer_inn || item.customer'>
            {{ item.customer_inn }} | {{ item.customer }}
          </div>
          <div v-else>
            <span>N/A</span>
          </div>
        </template>
        <template v-slot:item.user="{ item }">
          {{ moment(item.updatedAt).format("HH:mm DD.MM.YYYY") }}
        </template>
        <template v-slot:item.actions="{ item }">
          <template v-if="item.user_id == 24">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  :loading="false"
                  icon
                  @click="deleteCalculation(item)"
                >
                  <v-icon v-on="on">delete</v-icon>
                </v-btn>
              </template>
              <span>Удалить расчет</span>
            </v-tooltip>
          </template>
          &nbsp;
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn small :loading="false" icon @click="sendToCalc(item)">
                <v-icon v-on="on">fa fa-calculator</v-icon>
              </v-btn>
            </template>
            <span>Переход в калькулятор</span>
          </v-tooltip>

          &nbsp;
          <v-tooltip bottom v-if="item.table">
            <template v-slot:activator="{ on }">
              <v-btn
                small
                :loading="false"
                icon
                @click="sendToCalcResult(item)"
              >
                <v-icon v-on="on">fa fa-eye</v-icon>
              </v-btn>
            </template>
            <span>Переход к расчету</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import headers from './calcRegister/calcHeaders'

export default {
  watch: {
    "pagination.page": {
      handler() {
        this.go();
      },
      // deep: true,
    },
  },
  async created() {
    await this.checkData();
  },
  async mounted() {
    // const RegionsRE = this.$store.getters.getRegionRe;
    // if (!RegionsRE.length) {
    //   this.$store.dispatch("getRegionsRe");
    // }
    this.go();
  },
  computed: {
    // regions() {
    //   return this.$store.getters.getRegionRe;
    // }
    SearchedCalcData() {
      if (this.search !== "") {
        const data = this.DeepCopy(this.calculationsData)
        const searchReg = new RegExp(this.search, "ig");
        return data.filter((item) => {
          if (
            searchReg.test(item.customer_inn) ||
            searchReg.test(item.customer) ||
            searchReg.test(item.nmkc) ||
            searchReg.test(item.purchase_number) ||
            searchReg.test(item.summ) ||
            searchReg.test(item.dogovor_subject) ||
            searchReg.test(item.client_inn) ||
            searchReg.test(item.client_name)
          ) {
            return true;
          } else {
            return false;
          }
        });
      } else {
        return this.calculationsData;
      }
    },
  },
  data() {
    return {
      moment,
      search: "",
      calculationsData: [],
      pagination: {
        page: 1,
        itemsPerPage: 25,
        itemsLength: 0,
      },
      loading: false,
      headers,
      users: [],
    };
  },
  methods: {
    async checkData() {
      const Purchases = this.$store.getters.getPurchases;
      const Quarantees = this.$store.getters.getQuarantees;
      if (!Purchases.length || !Quarantees.length) {
        await this.$store.dispatch("SetLists");
      }
    },

    deleteCalculation(item) {
      this.loading = true;
      this.$store
        .dispatch("deleteMyCalculation", item.id)
        .then(() => {
          this.calculationsData = this.$store.getters.getCalculationsData;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    correctDate(param) {
      if (!this.filters[param]) return null;
      //const [year, month, day] = param.split(".");
      const [day, month, year] = this.filters[param].split(".");
      const CurrentDate = new Date();
      let fullYear = CurrentDate.getFullYear().toString();
      let yearVar = year;
      let monthVar = month - 1;
      let dayVar = day;
      if (year.length == 2) {
        yearVar = fullYear.substr(0, 2) + year;
      }
      if (yearVar < 2000 || yearVar >= 2050) {
        yearVar = CurrentDate.getFullYear();
      }
      if (monthVar < 0 || monthVar > 11) {
        monthVar = CurrentDate.getMonth().toString().padStart(2, "0");
      }

      if (dayVar < 1 || dayVar > 31) {
        dayVar = CurrentDate.getDate().toString().padStart(2, "0");
      }

      var d = new Date(yearVar, monthVar, dayVar);

      let resulcDate =
        d.getDate().toString().padStart(2, "0") +
        "." +
        (d.getMonth() + 1).toString().padStart(2, "0") +
        "." +
        d.getFullYear().toString();

      return resulcDate;
    },
    setPickerToNewDateUniversal(dateparam, calendarparam) {
      this.filters[dateparam] = this.correctDate(dateparam);
      this.filters[calendarparam] = this.dateToCalendar(
        this.filters[dateparam]
      );
    },
    InputDataPickerUniversal(dateparam, calendarparam, menu) {
      this[menu] = false;
      this.filters[dateparam] = this.calendarToDate(
        this.filters[calendarparam]
      );
    },
    OnChangeFinValAndFormatItValue(evt, param) {
      if (evt == "") return;
      const f = (x) =>
        x.toString().includes(".") ? x.toString().split(".").pop().length : 0;
      this.filters[param] = evt;
      if (this.filters[param].indexOf(",") != -1) {
        //evt.target.value = evt.target.value.split(",").join(".");
        this.filters[param] = this.filters[param].split(",").join(".");
      }
      this.filters[param] = this.filters[param].split(" ").join("");

      var kolSimvPoslTochki = f(this.filters[param]);

      switch (kolSimvPoslTochki) {
        case 0:
          this.filters[param] = this.filters[param] + ".00";
          break;
        case 1:
          this.filters[param] = this.filters[param] + "0";
          break;
        case 2:
          break;
        default:
          this.filters[param] = Math.trunc(this.filters[param] * 100) / 100;
          this.filters[param] = parseFloat(this.filters[param]) + 0.01;
          this.filters[param] = (
            Math.trunc(this.filters[param] * 100) / 100
          ).toFixed(2);
      }
      this.filters[param] = this.filters[param]
        .toString()
        .replace(/(\d)(?=(?:\d{3})+\.)/g, "$1 ");
    },

    OnFinSummChange: function (evt) {
      if (evt.key == "Enter") {
        return;
      }
      if (
        (evt.key == "." || evt.key == ",") &&
        (evt.target.value.indexOf(".") != -1 ||
          evt.target.value.indexOf(",") != -1)
      ) {
        event.preventDefault();
        return false;
      }
      var regex = new RegExp("[0-9,. ]");
      var key = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    },
    async go() {
      this.loading = true;
      this.calculationsData = [];

      const getObj = {
        selectedUser: parseInt(this.$store.getters.user_id),
        page: this.pagination.page,
        itemsPerPage: this.pagination.itemsPerPage,
      };
      const res = await this.$store.dispatch("getMyCalculationsData", getObj);
      this.pagination.itemsLength = res.itemsLength;
      this.calculationsData = res.data;
      this.loading = false;
    },
    showAdditional(data) {
      this.$store.dispatch("showAdditional", data).then(() => {
        this.dialogAdditional = true;
      });
    },

    intToYesNo(val) {
      if (val == 0) return "Нет";
      if (val == 1) return "Да";
      return "Нет";
    },

    // getClientSituation(val) {
    //   if (!val) return null;
    //   const your_situation = val.split(",");
    //   let arr = new Array();
    //   for (var i = 0; i < your_situation.length; i++) {
    //     arr[i] = Number.parseInt(your_situation[i]);
    //   }
    //   return arr;
    // },

    getDateNow(hours) {
      var today = new Date();
      today.setHours(today.getHours() + hours);
      var hh = today.getHours();
      var mm = today.getMinutes();
      if (hh < 10) hh = "0" + hh;
      if (mm < 10) mm = "0" + mm;
      return " " + hh + ":" + mm + " ";
    },
    getDateNowMinus(hours) {
      var today = new Date();
      today.setHours(today.getHours() - hours);
      var hh = today.getHours();
      var mm = today.getMinutes();
      if (hh < 10) hh = "0" + hh;
      if (mm < 10) mm = "0" + mm;
      return " " + hh + ":" + mm + " ";
    },

    getWinnerTimeFront(tz) {
      if (tz == "0" || tz == "") return this.getDateNow(0);
      if (tz[0] == "-")
        return this.getDateNowMinus(Number.parseInt(tz.slice(1)));
      if (tz[0] == "+") return this.getDateNow(Number.parseInt(tz.slice(1)));
      return this.getDateNow(Number.parseInt(tz));
    },

    showTimeZone(data) {
      this.$store.dispatch("getWinnerTime", data).then(() => {
        this.timeZone = this.$store.getters.getWinnerTime;
        this.dialogTZ = true;
      });
    },
    showWinnerInfo(data) {
      this.$store.dispatch("getWinnerinfo", data).then(() => {
        this.winnerInfo = this.$store.getters.getWinnerInfo;
        this.dialogWinner = true;
      });
    },
    getCustomerinfoForMyCalculations(data) {
      this.$store.commit("SET_CUSTOMER_INFO_INN", data.customer_inn);
      this.$store.commit("SET_CUSTOMER_INFO_NAME", data.customer_name);
      this.$store.commit("SET_CUSTOMER_INFO_TITLE", data.title);
      this.$store.commit("SET_SHOW_WINNERS_CUSTOMER_WINDOW", true);
    },
    getShortDateTime(dataString) {
      return dataString.slice(0, -3);
    },
    toggleFilter() {
      if (this.switch_filter_icon == "mdi-chevron-down") {
        this.switch_filter_icon = "mdi-chevron-up";
        this.switch_filter_text = "Развернуть";
        this.show = false;
      } else {
        this.switch_filter_icon = "mdi-chevron-down";
        this.switch_filter_text = "Свернуть";
        this.show = true;
      }
    },
    GetTableByWinnerID() {
      this.loading = true;
      var law;
      if (this.selectedLaw) {
        law = this.optionsLaw.filter((item) => item.id === this.selectedLaw)[0]
          .value;
      } else {
        law = "";
      }
      var dataArr = {
        date_from: this.filter_date_from,
        date_to: this.filter_date_to,
        number: this.filter_number,
        winner_inn: this.filter_inn,
        selectedAddTime: this.selectedAddTime,
        min_bg: this.filter_min_sum,
        max_bg: this.filter_max_sum,
        law: law,
        first_win: "",
        only_one: "",
        region: this.filter_region,
        selectedGeneral: [],
      };

      this.$store.dispatch("getProtocolData", dataArr).then(() => {
        this.protocolData = this.$store.getters.getProtocolData;
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss">
</style>
